import React, { FC, useState } from 'react';
import ProfileTitle from '../../customerDetail/CustomerProfile/ProfileTitle';
import './housingApplicationsDetails.scss';
import { formatCash } from '../../../utils/tableHelpers';

type Props = {
  payload: any;
}

const HouseApplicationsDetailsProfile: FC<Props> = ({ payload }) => {
  const [show, setShow] = useState(false);
  const infos = [
    { title: 'Type', value: payload?.apartmentType },
    { title: 'Monthly rent budget', value: formatCash(payload.monthlyBudget, 'C$') },
    { title: 'Monthly income', value: formatCash(payload.monthlyIncome, 'C$') },
    { title: 'City', value: payload?.city },
    { title: 'Province', value: payload?.province },
    { title: 'Fee paid', value: formatCash(payload.meta.feePaid, 'C$') },
  ];

  return (
    <div className="">
      <div className="">
        <ProfileTitle
          name="Apartment information"
          index={1}
          hasViewOnlyTab
          onClick={() => setShow((oldValue) => !oldValue)}
        />
      </div>
      {show && (
      <div className="address-details">
        {infos.map((info) => (
          <div data-type={info.title} className="address-details__info" key={info.title}>
            <h6 className="address-details__title">{info.title}</h6>
            <p className="address-details__value">{info.value}</p>
          </div>
        ))}
      </div>
      )}
    </div>
  );
};

export default HouseApplicationsDetailsProfile;
